/** Direct-checkout links for Single Product Switch landing CTAs. */

export function directCheckoutPath({ slug, variantId, qty = 1 }) {
  const s = String(slug || "").trim();
  if (!s) return "";
  const q = new URLSearchParams();
  q.set("buy", s);
  if (variantId) q.set("v", String(variantId));
  const n = Math.max(1, Math.min(99, Number(qty) || 1));
  if (n > 1) q.set("qty", String(n));
  return `/checkout?${q.toString()}`;
}

export function parseDirectCheckoutSearch(search) {
  const raw = String(search || "");
  const q = new URLSearchParams(raw.startsWith("?") ? raw.slice(1) : raw);
  const buy = (q.get("buy") || "").trim();
  if (!buy) return null;
  const qty = Math.max(1, Math.min(99, parseInt(q.get("qty") || "1", 10) || 1));
  const variantId = (q.get("v") || "").trim() || null;
  return { slug: buy, variantId, qty };
}
